export enum OttopilotContestsWorkspaceCapabilityAccessOperation {
    create = "551452d1-d8c5-49e4-9463-2d11cea9db9f",
    read = "10635c61-d2b0-46c1-a9ff-fc49c06b055a",
    update = "dd38d72c-fd2d-4e59-ae76-b7ca057d3033",
    delete = "2d1afdf4-3fd3-4f8b-9002-3b69dbc7a996",
}
